export default __webpack_public_path__ + "static/media/thurs-gray.376e8d5b.png";